import api from './api';
import { API_ENDPOINTS } from '../config/api';

interface LoginCredentials {
  email: string;
  password: string;
}

interface User {
  id: string;
  email: string;
  name: string;
  role: string;
}

interface LoginResponse {
  success: boolean;
  token: string;
  user: User;
}

class AuthService {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    try {
      const response = await api.post<LoginResponse>(API_ENDPOINTS.LOGIN, credentials);
      
      if (response.data.success) {
        // Save token and user data
        localStorage.setItem('fotomista_token', response.data.token);
        localStorage.setItem('fotomista_user', JSON.stringify(response.data.user));
        localStorage.setItem('adminAuthenticated', 'true'); // For backward compatibility
      }
      
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'فشل تسجيل الدخول');
    }
  }

  async getProfile(): Promise<User> {
    try {
      const response = await api.get(API_ENDPOINTS.PROFILE);
      return response.data.user;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'فشل جلب البيانات');
    }
  }

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    try {
      await api.put(API_ENDPOINTS.CHANGE_PASSWORD, {
        currentPassword,
        newPassword
      });
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'فشل تغيير كلمة المرور');
    }
  }

  logout(): void {
    localStorage.removeItem('fotomista_token');
    localStorage.removeItem('fotomista_user');
    localStorage.removeItem('adminAuthenticated');
  }

  isAuthenticated(): boolean {
    return !!(localStorage.getItem('fotomista_token') || 
              localStorage.getItem('adminToken') || 
              sessionStorage.getItem('adminAuthenticated'));
  }

  getUser(): User | null {
    const userStr = localStorage.getItem('fotomista_user');
    return userStr ? JSON.parse(userStr) : null;
  }

  isAdmin(): boolean {
    const user = this.getUser();
    return user?.role === 'admin';
  }
}

export const authService = new AuthService();